import React, { useState, useEffect } from 'react'

import { firestore } from '../../firebase'

import './Scrollmenu.css'

function PostCategories({activeCategory, setActiveCategory}) {

    const [isLoading, setIsLoading] = useState(true)
    const [categories, setCategories] = useState([])

    useEffect(() => {
        async function getBlogCategories() {
            setIsLoading(true)
            try {
                const categoriesRef = firestore.collection("recipeCategories");
                
                categoriesRef.onSnapshot(({docs}) => {
                    const categories = docs.map(doc => {
                        return {id: doc.id, ...doc.data()}
                    })
                    setCategories(categories)
                })              
            } catch (error) {
                console.log(error)
            }
            setIsLoading(false)
        }
        getBlogCategories()
    }, [])

    return (
        <div className="scrollmenu">

            <div className="col-lg-2 col-md-3 col-4 mb-2">
                <div 
                    style={ activeCategory === "all" ? {backgroundColor: ""} : {backgroundColor: "rgb(101, 64, 28)"}}
                    className={activeCategory === "all" ? 
                    "btn btn-outline-primary btn btn-sm btn-rounded btn-block" : 
                    "btn btn-sm btn-rounded btn-block text-white"} 
                    onClick={(e) => {setActiveCategory("all")}}
                >
                    Alle
                </div>
            </div>
            {categories && categories.map((category, index) => {

                let color
                if (index === 0 || index === 6) {
                    color = "rgb(181, 144, 98)";
                } else if (index === 1 || index === 7) {
                    color = "rgb(110, 120, 119)"
                } else if (index === 2 || index === 8) {
                    color = "rgb(208, 163, 134)"
                } else if (index == 3 || index === 9) {
                    color = "rgb(137, 125, 119)"
                } else if (index === 4 || index === 10) {
                    color = "rgb(49, 43, 39)"
                } else if (index === 5 || index === 11) {
                    color = "rgb(101, 64, 28)"
                } else {
                    color = "rgb(159, 137, 99)"
                }

                return (
                    <div className="col-lg-2 col-md-3 col-5 mb-2" key={index}>
                        <div 
                            style={{backgroundColor: color}} 
                            className={activeCategory === category.id ? 
                            "btn btn-outline-primary btn btn-sm btn-rounded btn-block btn-success-dark" : 
                            "btn btn-sm btn-rounded btn-block text-white"} 
                            onClick={(e) => {setActiveCategory(category.id)}}
                        >
                            {category.category}
                        </div>
                    </div>
                )

            })}
        </div>
    )
}
export default PostCategories